import i18n from 'helpers/i18n';
import messages from './messages';
import { Box } from 'components/Box';
import MainContent from 'components/MainContent';
import PageBackground from 'components/PageBackground';
import {
  LogoImg,
  Subtitle,
  Title,
  TitleWrapper
} from 'components/PageHeader/Styled';
import PageWrapper from 'components/PageWrapper';
import { ContainerSection as Section } from 'components/Reports/Reliability/View/Styled';
import logoCertification from 'images/reliabilityTest/logoCertification.svg';
import { PageHeaderWrapper } from 'components/TestAttempts/Styled';
import classExtensionMobileIcon from 'images/reliability/ClassExtensionMobile.png';
import { useMediaQuery } from 'react-responsive';
import { TS_SUPPORT_URL } from 'constants/environmentVariables';
import { Button } from '@teachstonellc/component-library';

interface ExpiredCalibrationProps {
  calibration_name?: string | null;
}

function ExpiredCalibration({ calibration_name }: ExpiredCalibrationProps) {
  const isTablet = useMediaQuery({ minWidth: 768 });

  return (
    <MainContent maxWidth={1280}>
      <PageWrapper borderStyle>
        <PageHeaderWrapper>
          <TitleWrapper>
            <LogoImg src={logoCertification} alt={i18n.ft(messages.logoAlt)} />
            <Title>{calibration_name || i18n.ft(messages.title)}</Title>
            <Subtitle>{i18n.ft(messages.subtitle)}</Subtitle>
          </TitleWrapper>
        </PageHeaderWrapper>
        <PageBackground borderStyle>
          <Box>
            <Section
              mt="8px"
              px="48px"
              py="24px"
              mx={{ _: '0px', lg: '32px' }}
              isMobile
              borderTopRadius={isTablet ? '12px' : ''}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 py-[100px]">
                <div className="col-span-5">
                  <img
                    src={classExtensionMobileIcon}
                    alt={i18n.ft(messages.iconAlt)}
                    style={{ width: '120px' }}
                    className="mx-auto"
                  />
                </div>

                <div className="col-span-7">
                  <div className="flex flex-col h-full">
                    <p className="text-center text-lg">
                      {i18n.ft(messages.expiredMessage)}
                    </p>
                    <div className="grid w-full mt-auto mb-2">
                      <Button
                        as="a"
                        href={TS_SUPPORT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="primary"
                        className="mt-5 justify-self-center"
                      >
                        {i18n.ft(messages.contactSupport)}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Section>
          </Box>
        </PageBackground>
      </PageWrapper>
    </MainContent>
  );
}

export default ExpiredCalibration;
